/* Theme integration for the pinned Archon capture SDK. No checkout interception. */
(function () {
  'use strict';
  if (window.CszArchonTracking) return;
  var config = document.currentScript;
  var capture = null;
  var starting = null;
  var retryTimer = null;
  var stopped = false;
  var status = 'waiting';
  var POLL_MS = 250;
  var INITIALIZATION_POLLS = 80; // Accommodates the theme's nine-second Shopify delay.
  var PRIVACY_LOAD_TIMEOUT_MS = 10000;
  var CART_RETRY_DELAY_MS = 150;

  function report(next, code) {
    status = next;
    document.dispatchEvent(new CustomEvent('csz:acquisition-status', {
      detail: { status: next, code: code || null }
    }));
    if (next === 'failed') {
      console.warn(JSON.stringify({ action: 'acquisition.theme', status: next, code: code }));
    }
  }
  function onCapture(event) {
    var next = event.detail && event.detail.status;
    if (['saved', 'cleared', 'failed'].indexOf(next) !== -1) {
      report(next, next === 'failed' ? 'ACQUISITION_CAPTURE_FAILED' : null);
    }
  }
  function privacyReady() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return privacy && typeof privacy.analyticsProcessingAllowed === 'function' &&
      typeof privacy.marketingAllowed === 'function';
  }
  function loadPrivacy() {
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () { reject(new Error('PRIVACY_LOAD_TIMEOUT')); }, PRIVACY_LOAD_TIMEOUT_MS);
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
          clearTimeout(timer);
          if (error || !privacyReady()) reject(new Error('PRIVACY_LOAD_FAILED'));
          else resolve();
        });
      } catch (error) {
        clearTimeout(timer);
        reject(new Error('PRIVACY_LOAD_FAILED'));
      }
    });
  }
  async function initialize() {
    var origins = [config && config.dataset.shopUrl, config && config.dataset.myshopifyUrl].map(function (raw) {
      var url = new URL(raw);
      if (url.protocol !== 'https:' || url.username || url.password) throw new Error('INVALID_STOREFRONT_CONFIG');
      return url.origin;
    });
    if (origins.indexOf(window.location.origin) === -1) throw new Error('UNAPPROVED_STOREFRONT');
    for (var attempt = 0; attempt < INITIALIZATION_POLLS && !stopped; attempt++) {
      if (privacyReady()) break;
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        await loadPrivacy();
        break;
      }
      await new Promise(function (resolve) { setTimeout(resolve, POLL_MS); });
    }
    if (stopped) return;
    if (!privacyReady()) throw new Error('PRIVACY_API_UNAVAILABLE');
    if (!window.ArchonAcquisition || typeof window.ArchonAcquisition.start !== 'function') throw new Error('CAPTURE_SDK_UNAVAILABLE');
    capture = window.ArchonAcquisition.start({ ownOrigins: origins });
    await capture.ready;
    // The SDK emits saved/cleared/failed. No event on an initial denied visit means no collection.
    if (status === 'waiting') report('not_collecting');
  }
  function retry() {
    if (stopped) return Promise.resolve();
    if (starting) return starting;
    if (capture) return capture.sync();
    report('waiting');
    starting = initialize().catch(function (error) {
      var allowedCodes = ['INVALID_STOREFRONT_CONFIG', 'UNAPPROVED_STOREFRONT', 'PRIVACY_LOAD_TIMEOUT', 'PRIVACY_LOAD_FAILED', 'PRIVACY_API_UNAVAILABLE', 'CAPTURE_SDK_UNAVAILABLE'];
      report('failed', allowedCodes.indexOf(error.message) === -1 ? 'CAPTURE_INITIALIZATION_FAILED' : error.message);
    }).finally(function () { starting = null; });
    return starting;
  }
  function requestRetry() {
    if (retryTimer !== null || stopped) return;
    retryTimer = setTimeout(function () { retryTimer = null; void retry(); }, CART_RETRY_DELAY_MS);
  }
  function stop() {
    stopped = true;
    clearTimeout(retryTimer);
    if (capture) capture.stop();
    document.removeEventListener('archon:acquisition', onCapture);
    document.removeEventListener('cart:updated', requestRetry);
    document.removeEventListener('StartAsyncLoading', requestRetry);
    window.removeEventListener('online', requestRetry);
    report('stopped');
  }
  window.CszArchonTracking = Object.freeze({
    get status() { return status; },
    retry: retry,
    stop: stop
  });
  document.addEventListener('archon:acquisition', onCapture);
  document.addEventListener('cart:updated', requestRetry);
  document.addEventListener('StartAsyncLoading', requestRetry);
  window.addEventListener('online', requestRetry);
  void retry();
})();
